
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy-main",
      function () {
        return require("private-next-pages/privacy-policy-main.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy-main"])
      });
    }
  